import { type Descendant } from 'slate';

import { Element } from '@@editor/helpers';

const isState = (state: any): state is Descendant[] => Element.isElementList(state);

export default isState;
